<nav class="vertical-navbar-wrap">
    <app-menu *ngIf="isMenuVisible"></app-menu>
</nav>

<div class="sidebar-overlay"></div>
